import React from 'react';
import { VideoItem } from '../constants/videos';
import { VideoCard } from './video-card';

interface VideoGridProps {
  videos: VideoItem[];
  onOpenReel: (index: number) => void;
}

export const VideoGrid: React.FC<VideoGridProps> = ({ videos, onOpenReel }) => {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
      gap: 16,
    }}>
      {videos.map((video, index) => (
        <VideoCard
          key={video.id}
          video={video}
          onOpenReel={() => onOpenReel(index)}
        />
      ))}
    </div>
  );
};
